import { IntelligencePersona } from '@@types/api.types';
import { formOptions } from '@tanstack/react-form';
import { z } from 'zod/v4';

export type AdminOrganizationHierarchyFormData = {
  childOrganizationIds: string[];
  draftIsParentOrganization: boolean;
  draftParentOrganizationIds: string[];
};

export const adminAddIntelMemberSchema = z.object({
  persona: z.enum(IntelligencePersona, { message: 'Please select a persona.' }),
  userId: z.uuid({ message: 'Please select a user.' }),
});

export type AdminAddIntelMemberFormData = {
  persona: IntelligencePersona | null;
  userId: string | null;
};

export const adminAddIntelMemberFormOptions = formOptions({
  defaultValues: {
    persona: null,
    userId: null,
  } as AdminAddIntelMemberFormData,
});

export type AdminOrganizationSlugFormData = {
  slug: string;
};

export type AdminOrganizationTagsFormData = {
  selectedTagNames: string[];
};

export const adminOrganizationHierarchyFormOptions = formOptions({
  defaultValues: {
    childOrganizationIds: [],
    draftIsParentOrganization: false,
    draftParentOrganizationIds: [],
  } as AdminOrganizationHierarchyFormData,
});

export const adminOrganizationSlugFormOptions = formOptions({
  defaultValues: {
    slug: '',
  } as AdminOrganizationSlugFormData,
});

export const adminOrganizationTagsFormOptions = formOptions({
  defaultValues: {
    selectedTagNames: [],
  } as AdminOrganizationTagsFormData,
});
